/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFolder } from './DocumentFolder';
import {
    DocumentFolderFromJSON,
    DocumentFolderFromJSONTyped,
    DocumentFolderToJSON,
    DocumentFolderToJSONTyped,
} from './DocumentFolder';

/**
 * List of document folders for a claim.
 * @export
 * @interface ListDocumentFoldersResponse
 */
export interface ListDocumentFoldersResponse {
    /**
     * 
     * @type {Array<DocumentFolder>}
     * @memberof ListDocumentFoldersResponse
     */
    items: Array<DocumentFolder>;
}

/**
 * Check if a given object implements the ListDocumentFoldersResponse interface.
 */
export function instanceOfListDocumentFoldersResponse(value: object): value is ListDocumentFoldersResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListDocumentFoldersResponseFromJSON(json: any): ListDocumentFoldersResponse {
    return ListDocumentFoldersResponseFromJSONTyped(json, false);
}

export function ListDocumentFoldersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentFoldersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentFolderFromJSON)),
    };
}

export function ListDocumentFoldersResponseToJSON(json: any): ListDocumentFoldersResponse {
    return ListDocumentFoldersResponseToJSONTyped(json, false);
}

export function ListDocumentFoldersResponseToJSONTyped(value?: ListDocumentFoldersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DocumentFolderToJSON)),
    };
}

